import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 768px) {
    display: grid;
  }
`;
export const ContainerProduct = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const ProductDetailsContainer = styled.div`
  border-radius: 10px;
  background-color: white;
  padding: 35px;
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;

  -webkit-box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.2);

  img {
    border-radius: 5px;
    border: 2px red;
  }
`;
export const ProductDetailsContainerLeft = styled.div`
  padding: 5px;
  color: blue;
  width: 40%;
  display: flex;
  flex-direction: column;

  .product-details-container-left-top {
    img {
      width: 100%;
      height: 550px;

      @media (max-width: 768px) {
        height: 150px;
      }
    }
  }
  .product-details-container-left-bot {
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 150px;
      height: auto;
      margin: 5px;
    }
  }
`;
export const ProductDetailsContainerRight = styled.div`
  padding: 5px;
  width: 60%;
  display: flex;
  flex-direction: column;

  .product-name-title-container {
    h1 {
      color: #002666;
    }
  }
  .publication-date-text {
    color: gray;
  }
  .product-code-text {
    color: black;
    font-weight: bold;
  }

  .product-price-seller-container {
    display: flex;
    flex-direction: row;
  }
  .product-detail-price {
    width: 50%;
    height: 180px;
    padding-right: 45px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin: 20px 0px 0px 20px;

    button {
      border: none;
      background: #ce1720;
      color: white;
      font-weight: bold;
      padding: 20px 70px;
      border-radius: 10px;

      @media (max-width: 768px) {
        padding: 10px 10px;
        width: 180px;
      }
    }
  }
  .product-detail-stats-vendor {
    color: green;
    font-weight: bold;
  }

  .product-detail-iten-price {
    font-size: 42px;
    color: #002666;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 38px;
      margin-left: -20px;
    }
  }

  .product-detail-seller {
    width: 50%;
    background-color: #f7f7f7;
    padding: 25px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    margin: 30px 0px 0px 20px;

    @media (max-width: 768px) {
      display: none;
    }
  }
  .product-detail-seller-header {
    color: #feb300;
    font-weight: bold;
  }
  .product-detail-seller-name {
    color: #002666;
    font-size: 30px;
  }
  .product-detail-seller-since {
    color: #002666;
  }
  .product-detail-seller-see-all {
    color: gray;
    font-weight: bold;
    text-decoration: underline;
  }
  .product-detail-seller-send-msg {
    color: #ce1720;
    font-weight: bold;
    text-decoration: underline;
  }

  .product-description-container {
    padding-top: 50px;
    font-size: 20px;
    color: gray;
  }

  .details-product-seller-container {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin-top: 20px;
    font-size: 20px;
    color: gray;

    @media (max-width: 768px) {
      flex-wrap: wrap;
    }
  }

  .social-media-container {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    margin: 10px;

    @media (max-width: 768px) {
      flex-wrap: wrap;
    }

    button {
      width: 305px;
      height: 75px;
      padding: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      background: white;
      color: #ffb615;
      font-weight: bold;
      border-radius: 5px;
      border: 2px solid #ffb615;

      @media (max-width: 1775px) {
        width: 130px;
        height: 50px;
        padding: 6px;
        margin: 6px;
      }
    }
  }

  .security-hints-container {
    background: #f7f7f7;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: gray;
    padding: 10px 20px;

    i {
      font-size: 32px;
      color: red;
      margin-right: 10px;
    }

    h6 {
      color: red;
      font-size: 16px;
    }

    h5 {
      color: gray;
      font-size: 18px;
    }
  }
`;

export const Breadcrumbs = styled.div`
  color: #fff;
  padding: 20px 0;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  display: flex;
  flex-direction: row;

  .breadcrumbs-start {
    margin-right: 25px;
    padding-right: 25px;
    border-right: 1px solid blue;

    a {
      color: #ffb615;
      text-decoration: underline;
    }
  }

  .breadcrumbs-main {
    i {
      color: #ffb615;
    }
  }
`;
